var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bankPrivacyJson"},[_c('div',{staticStyle:{"line-height":"25px"},domProps:{"innerHTML":_vm._s(_vm.bankPrivacy)}},[_vm._v("\n    "+_vm._s(_vm.bankPrivacy)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }